import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private ORDERFORMS_PREFIX = 'DSOrderformsv1-';

  setStoreItem(key: string, value: any): void {
    localStorage.setItem(this.ORDERFORMS_PREFIX + key, JSON.stringify(value));
  }

  getStoreItem(key: string): any | null {
    const item = localStorage.getItem(this.ORDERFORMS_PREFIX + key);

    if (!item) {
      return null;
    }

    return JSON.parse(item);
  }

  removeItem(key: string) {
      localStorage.removeItem(this.ORDERFORMS_PREFIX + key);
  }

  setSessionItem(key: string, value: any): void {
    sessionStorage.setItem(this.ORDERFORMS_PREFIX + key, JSON.stringify(value));
  }

  getSessionItem(key: string): any | null {
    const item = sessionStorage.getItem(this.ORDERFORMS_PREFIX + key);

    if (!item) {
      return null;
    }

    return JSON.parse(item);
  }

  removeSessionItem(key: string) {
    sessionStorage.removeItem(this.ORDERFORMS_PREFIX + key);
  }
}
